
$('label.fs.filter').click(function () {
    $('.sort-options.filter').toggleClass('filter-vis');
    $('.sort-options.sort').removeClass('filter-vis');
});

$('label.fs.sort').click(function () {
    $('.sort-options.filter').removeClass('filter-vis');
    $('.sort-options.sort').toggleClass('filter-vis');
});

$(".menu-functions .cart-opener").click(function (e) {
    e.preventDefault();
    // $(".cart.cart-flyout").toggleClass("cart-active");
    // $(this).attr('aria-expanded', 'true')
  window.Rebuy.SmartCart.show();
});

$(".header__cart-holder .cart-closer").click(function (e) {
    e.preventDefault();
    $(".cart.cart-flyout").removeClass("cart-active");
  	$('.cart-opener').attr('aria-expanded', 'false')
});

$(document).ready(function(e) {
    $(function() {
      // hide the Notify me form if the variant options combination does not exist
      var _origSelectCallback = window.selectCallback;
      window.selectCallback = function(variant, selector) {
        _origSelectCallback.apply(window, arguments);
        if (variant == null) {
          $('#notify-form-{{product.id}}').stop().hide();
        }
      }
    });

    // actions
    $('body')
    .on('focus change', '.notify_form input', function() {
        $('.notify_form .BIS_response').text('');
    })

    .on('change', '.product_form select', function() {
        $('.notify_form .BIS_response').text('');
    })

    .on('change', '.shopify-product-form select', function() {
      const productForm = $(this).closest(".shopify-product-form");
      const variantID = productForm.find('[name="id"]').val();
      if(productForm.find('[name="id"]').length) {
        const availablilityVariant = productForm.find('[name="id"]').find(':selected').attr('data-available');
        if(availablilityVariant == 'false') {
          productForm.find(".heading-qty-label").hide();
          productForm.find(".prod-page-form").hide();
          productForm.find(".hc_cd").hide();
          productForm.find(".container--zest_pdp").hide();
          productForm.find(".bulk-section-wrapper").hide();
          productForm.find("[data-rebuy-id]").hide();
          productForm.find("shopify-payment-terms").hide();
        } else {
          productForm.find(".heading-qty-label").show();
          productForm.find(".prod-page-form").css("display", "flex");
          productForm.find(".hc_cd").css("display", "flex"); 
          productForm.find(".container--zest_pdp").show();
          productForm.find(".bulk-section-wrapper").show();
          productForm.find("[data-rebuy-id]").show();
          productForm.find("shopify-payment-terms").show();
        }
      }
    })

    .on('click', 'a.open-more', function() {
        $(this).siblings('.open-description').hide();
        $(this).siblings('.full-description').addClass('show-more').show();
        $(this).parent('.desc-wrapper').addClass('show-more');
        $(this).addClass('show-more');
    })

    .on('click', '.learn-more-opener', function() {
        $(".learn-more-shipping").toggle();
        $(this).text(function(i, v) {
            return v === 'more details' ? 'hide details' : 'more details'
        })
    })

    .on('click', '.btn.write-a-review', function() {
        $('.write-review-wrapper.write-form').show();
    })

    .on('click', '.pre-click.btn', function() {
        $(this).next().addClass('vis');
        $(this).hide();
    })

    .on('click', '.quickview-pop', function(e) { 
        let $this = $(this);
        let targetId = $this.data('prod-id');
      
      	$(`.quickview-popup.prod-id-${targetId} .quantity.ot-quantity`).val(1);
        $(`.quickview-popup.prod-id-${targetId} .listDiscount`).removeClass("checked-box active"); 

        $(`.quickview-popup.prod-id-${targetId}`).addClass('qv-active');
        if ($this.find('.product-slider1').hasClass('slick-initialized')) { 
            $this.find('.product-slider1').slick('setPosition');
        }
    })

    .on('click', '.quickview-popup-close, .quickview-popup-overlay', function() { 
      $('.quickview-popup').removeClass('qv-active');
    })

    .on('change', 'input[name="quantity"]', function (e) {
        //Check if bulk discount is available for the product.

        if (!$('.just-bulk').length) {
            return;
        }
        var listOfDiscountOptions = '';

        if ($(this).parents('.qv-active').length > 0) {
            listOfDiscountOptions = $('.qv-active .listDiscount');
        } else {
            listOfDiscountOptions = $('.listDiscount');
        }
        var qty = this.value;
//         console.log(listOfDiscountOptions);

        if (qty < listOfDiscountOptions.eq(0).data('bulk-qty')) {
            listOfDiscountOptions.removeClass('checked-box active');
            return;
        }

        for (var i = listOfDiscountOptions.length - 1; i >= 0;  i-- ) {
            var $element = listOfDiscountOptions.eq(i);
            var threshold = $element.data('bulk-qty');

            if (qty >= threshold) {
                listOfDiscountOptions.removeClass('checked-box active');
                $element.addClass('checked-box active');
                break;
            }
        }
    })

    /*
    */
    .on('click', '.js-load-more', function() { 
        let $btn        = $(this),
            totalPages  = parseInt($('[data-total-pages]').val()),
            currentPage = parseInt($('[data-current-page]').val());
        
        // $btn.find('[load-more-text]').addClass('hide');

        // let nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
        let nextUrl = $('[data-next-url]').val();
        let ajaxUrl = '';
        if ( nextUrl.includes('?') ) { 
            ajaxUrl = nextUrl + '&view=ajax';
        } else { 
            ajaxUrl = nextUrl + '?view=ajax';
        }

        currentPage += 1;

        $btn.attr('disabled', true);
        $btn.find('span').addClass('fa-spin');

        window.ajax_locked = true;

        $.ajax({
            url: ajaxUrl,
            type: 'GET',
            dataType: 'html',
            success: function(responseHTML) {
                $('.collection-list').append(responseHTML);

                window.ajax_locked = false;

                $btn.removeAttr('disabled');
                $btn.find('span').removeClass('fa-spin');

                if ( currentPage == totalPages ) { 
                    $btn.attr('disabled', true);
                    $btn.hide();
                } else { 
                    $('[data-current-page]').val(currentPage);

                    nextUrl = nextUrl.replace(/page=[0-9]+/, 'page='+(currentPage+1));
                    $('[data-next-url]').val(nextUrl);
                }

                if ( window.ReCharge ) { 
                    ReCharge.run();
                }

                if ( window.yotpo ) { 
                    yotpo.refreshWidgets();
                } else { 
                    var api = new Yotpo.API(yotpo);
                    api.refreshWidgets();
                }

              // // Start Cookie
              // if ($.cookie('FB_SANTOKU') == 'yes') {
              //    $('.identify-milk-street-santoku').hide();
              //   } 
              // else { 
              //   $('.identify-milk-street-santoku-deal').hide();
              //  }

              // // Start Cookie
              // if ($.cookie('FB_AUX_SUKUERE_KNIFE') == 'yes') {
              //    $('.identify-aux-co-ltd-japan-sukueru-knife').hide();
              //   } 
              // else { 
              //   $('.identify-aux-co-ltd-japan-sukueru-knife-deal').hide();
              //  }

              // // Start Cookie
              // if ($.cookie('FB_SOFRITO') == 'yes') {
              //    $('.identify-milk-street-sofrito').hide();
              //   } 
              // else { 
              //   $('.identify-milk-street-sofrito-deal').hide();
              //  }

              //  // Start Cookie
              // if ($.cookie('FB_GARLIC_CONFIT') == 'yes') {
              //    $('.identify-milk-street-garlic-confit').hide();
              //   } 
              // else { 
              //   $('.identify-milk-street-garlic-confit-deal').hide();
              //  }

              //  // Start Cookie
              // if ($.cookie('FB_FUJI_70_CLEAVER') == 'yes') {
              //    $('.identify-fuji-cutlery-fa-70-chinese-style-cleaver').hide();
              //   } 
              // else { 
              //   $('.identify-fuji-cutlery-fa-70-chinese-style-cleaver-deal').hide();
              //  }

              //   // Start Cookie
              // if ($.cookie('REFER_FIVE_PANTRY') == 'yes') {
              //    $('.identify-mymoune-pomegranate-molasses').hide();
              //   } 
              // else { 
              //   $('.identify-mymoune-pomegranate-molasses-deal').hide();
              //  }

              //    // Start Cookie
              // if ($.cookie('FB_ALPHONSO_MANGO') == 'yes') {
              //    $('.identify-pure-indian-foods-alphonso-mango-puree').hide();
              //   } 
              // else { 
              //   $('.identify-pure-indian-foods-alphonso-mango-puree-deal').hide();
              //  }

              // // Start Cookie
              // if ($.cookie('FB_CALAMANSI_VINEGAR') == 'yes') {
              //    $('.identify-huilerie-beaujolaise-calamansi-vinegar').hide();
              //   } 
              // else { 
              //   $('.identify-huilerie-beaujolaise-calamansi-vinegar-deal').hide();
              //  }

              //   // Start Cookie
              // if ($.cookie('FB_SHIO_KOJI') == 'yes') {
              //    $('.identify-hanamaruki-foods-liquid-shio-koji').hide();
              //   } 
              // else { 
              //   $('.identify-hanamaruki-foods-liquid-shio-koji-deal').hide();
              //  }

              //    // Start Cookie
              // if ($.cookie('FB_SHIO_KOJI') == 'yes') {
              //    $('.identify-hanamaruki-foods-liquid-shio-koji').hide();
              //   } 
              // else { 
              //   $('.identify-hanamaruki-foods-liquid-shio-koji-deal').hide();
              //  }

              //   // Start Cookie
              // if ($.cookie('FB_MAGACHEF_OYSTER_SAUCE') == 'yes') {
              //    $('.identify-megachef-premium-oyster-flavored-sauce').hide();
              //   } 
              // else { 
              //   $('.identify-megachef-premium-oyster-flavored-sauce-deal').hide();
              //  }
      

              //  // Start Cookie
              // if ($.cookie('REFER_FIVE_PANTRY') == 'yes') {
              //    $('.identify-megachef-premium-oyster-flavored-sauce').hide();
              //   } 
              // else { 
              //   $('.identify-megachef-premium-oyster-flavored-sauce-deal').hide();
              //  }

              //    // Start Cookie
              // if ($.cookie('FB_CASABLANCA_LEMONS') == 'yes') {
              //    $('.identify-casablanca-market-preserved-lemons-from-morocco').hide();
              //   } 
              // else { 
              //   $('.identify-casablanca-market-preserved-lemons-from-morocco-deal').hide();
              //  }

              //       // Start Cookie
              // if ($.cookie('FB_VILLA_JERADA_HARISSA') == 'yes') {
              //    $('.identify-villa-jerada-harissa').hide();
              //   } 
              // else { 
              //   $('.identify-villa-jerada-harissa-deal').hide();
              //  }

              // // Start Cookie
              // if ($.cookie('FB_PAZAAR_KOZMATIK') == 'yes') {
              //    $('.identify-pazaar-kozmatik').hide();
              //   } 
              // else { 
              //   $('.identify-pazaar-kozmatik-deal').hide();
              //  }

              // // Start Cookie
              // if ($.cookie('FB_MS_RATCHET_GRINDER') == 'yes') {
              //    $('.identify-milk-street-ratchet-grinder-and-storage-jar').hide();
              //   } 
              // else { 
              //   $('.identify-christopher-kimball-for-kuhn-rikon-ratchet-grinder-deal').hide();
              //  }

              //   // Start Cookie
              // if ($.cookie('FB_MOHA_GRATER') == 'yes') {
              //    $('.identify-moha-ginger-grater').hide();
              //   } 
              // else { 
              //   $('.identify-moha-ginger-grater-deal').hide();
              //  }

              //    // Start Cookie
              // if ($.cookie('FB_EVER_PEELER') == 'yes') {
              //    $('.identify-suncraft-ever-peeler').hide();
              //   } 
              // else { 
              //   $('.identify-ever-peeler-by-suncraft-deal').hide();
              //  }

              //      // Start Cookie
              // if ($.cookie('FB_MICROPLANE_SLICER') == 'yes') {
              //    $('.identify-microplane-garlic-slicer-mincer-set').hide();
              //   } 
              // else { 
              //   $('.identify-microplane-garlic-slicer-mincer-set-deal').hide();
              //  }

              //       // Start Cookie
              // if ($.cookie('FB_DROP_LID') == 'yes') {
              //    $('.identify-otoshibuta-adjustable-stainless-steel-drop-lid').hide();
              //   } 
              // else { 
              //   $('.identify-otoshibuta-adjustable-stainless-steel-drop-lid-deal').hide();
              //  }

              //          // Start Cookie
              // if ($.cookie('FB_BOX_GRATER') == 'yes') {
              //    $('.identify-cuisipro-box-grater').hide();
              //   } 
              // else { 
              //   $('.identify-cuisipro-box-grater-deal').hide();
              //  }

              //           // Start Cookie
              // if ($.cookie('FB_CUTTING_BOARD_MAT') == 'yes') {
              //    $('.identify-hasegawa-waterproof-non-slip-cutting-board-mat').hide();
              //   } 
              // else { 
              //   $('.identify-hasegawa-waterproof-non-slip-cutting-board-mat-deal').hide();
              //  }

              //            // Start Cookie
              // if ($.cookie('FB_SESERAGI_BREAD_KNIFE') == 'yes') {
              //    $('.identify-suncraft-seseragi-bread-knife').hide();
              //   } 
              // else { 
              //   $('.identify-suncraft-seseragi-bread-knife-deal').hide();
              //  }

              
              
            }
        })
    })

    .on('click', '.js-trigger-preorder', function(event) { 
        event.preventDefault();

        var $button = $(this),
            $form   = $button.closest('form');

        if($button.hasClass("quiet-preorder")){
            $form.find("button.add_to_cart").click();
        } else {
            $form.find('.js-preorder-modal').addClass('is-open');
            $('body').addClass('remove-sticky'); 
        }
    })

    .on('click', '.js-preorder-modal--close, .preorder-modal--overlay', function(event) { 
        event.preventDefault();

        $('.js-preorder-modal').removeClass('is-open');
        $('body').removeClass('remove-sticky');
    })

    
    const makeGiftCTAsSlider = function() { 
        if ( ! $(`.gifting-cta__wrapper`).hasClass('slick-initialized') ) {
            $(`.gifting-cta__wrapper`).slick({
                arrow: true,
                dots: true,
                centerMonde: true,
                centerPadding: '60px',
                fade: false
                // slide: '.gifting-cta__item'
            }).slick('slickGoTo', 1)
        }
    }

    const removeGiftCTAsSlider = function() {
        if ( $(`.gifting-cta__wrapper`).hasClass('slick-initialized') ) { 
            $(`.gifting-cta__wrapper`).slick('unslick');
        }
    }


    $(window)
    .on('scroll', function() { 
        if ( $('.js-load-more').length ) { 
            const currentTop = $(window).scrollTop();
            const windowHeight = $(window).height();

            const containerTop = $('.collection-list').offset().top;
            const containerHeight = $('.collection-list').height();

            if ( (currentTop + windowHeight + 600) > (containerTop + containerHeight) && window.ajax_locked !== true ) { 
                // console.log("'Load More' button is Triggered");

                $('.js-load-more').trigger('click');
            }
        }
    })

    .on('load', function() {
        if ( $(window).width() < 1024 ) { 
            makeGiftCTAsSlider();
            return;
        }
    })

    .on('resize', function() {
        if ( $(window).width() < 1024 ) { 
            makeGiftCTAsSlider();
        } else {
            removeGiftCTAsSlider();
        }
    })
});
